<template>
  <v-layout row wrap py-3>
    <v-flex xs12 md12>
      <v-layout row wrap>
        <v-flex xs12 md4 pa-1 v-for="(r, i) in resource.data" :key="'resource-'+i">
          <v-card :loading="loading">
            <v-layout wrap row align-baseline style="min-height:400px;">
              <v-flex xs12 style="height:2px;">
                <v-progress-linear height="2" class="pa-0 ma-0" v-if="loading" :indeterminate="true"></v-progress-linear>
              </v-flex>
              <v-flex xs7>
                <v-card-title primary-title>
                  <div>
                    <div style="text-transform:uppercase;font-size:11px;">
                      <v-chip label small v-for="(cat, c) in r.categories" :key="'cat-' + c" class="white--text" color="secondary" style="font-size:11px;">{{cat.name}}</v-chip>
                    </div>
                    <div style="font-weight:bold;">{{r.sku}} <span v-if="r.variants.length">*</span> </div>
                    <v-divider class="my-1"></v-divider>
                    <v-tooltip top>
                      <template slot="activator">
                        <div on="on" style="text-transform:uppercase;font-size:16px;font-weight:bold;line-height:15px;">{{r.item_name}}</div>
                      </template>
                      <div style="text-transform:uppercase;font-weight:bold;">description_web_en</div>
                      <div style="white-space: pre-line;" v-html="r.description_web_en"></div>
                      <div style="text-transform:uppercase;font-weight:bold;">description_web_ar</div>
                      <div style="white-space: pre-line;" v-html="r.description_web_ar"></div>
                    </v-tooltip>
                    <v-divider class="my-1"></v-divider>
                    <div style="text-transform:uppercase;font-weight:bold;">check list:</div>
                    <div style="text-transform:uppercase;font-size:11px;">
                      <v-icon v-if="r.image" color="success" size="15">done</v-icon>
                      <v-icon v-else color="error" size="15">close</v-icon>
                      image 
                    </div>
                    <div style="text-transform:uppercase;font-size:11px;">
                      <v-icon v-if="r.images && r.images.length > 1" color="success" size="15">done</v-icon>
                      <v-icon v-else color="error" size="15">close</v-icon>
                      other images 
                    </div>
                    <div style="text-transform:uppercase;font-size:11px;">
                      <v-icon v-if="r.name_en" color="success" size="15">done</v-icon>
                      <v-icon v-else color="error" size="15">close</v-icon>
                      name_en 
                    </div>
                    <div style="text-transform:uppercase;font-size:11px;">
                      <v-icon v-if="r.name_ar" color="success" size="15">done</v-icon>
                      <v-icon v-else color="error" size="15">close</v-icon>
                      name_ar 
                    </div>
                    <div style="text-transform:uppercase;font-size:11px;">
                      <v-icon v-if="r.description_en" color="success" size="15">done</v-icon>
                      <v-icon v-else color="error" size="15">close</v-icon>
                      description_en 
                    </div>
                    <div style="text-transform:uppercase;font-size:11px;">
                      <v-icon v-if="r.description_ar" color="success" size="15">done</v-icon>
                      <v-icon v-else color="error" size="15">close</v-icon>
                      description_ar 
                    </div>
                    <div style="text-transform:uppercase;font-size:11px;">
                      <v-icon v-if="r.prices.filter(x=>x.default).length > 0" color="success" size="15">done</v-icon>
                      <v-icon v-else color="error" size="15">close</v-icon>
                      default prices | {{ r.prices.filter(x=>x.default).length }} 
                    </div>
                    <div style="text-transform:uppercase;font-size:11px;">
                      <v-icon v-if="r.prices.filter(x=>x.web).length > 0" color="success" size="15">done</v-icon>
                      <v-icon v-else color="error" size="15">close</v-icon>
                      web prices | {{ r.prices.filter(x=>x.web).length }} 
                    </div>
                    <v-divider class="my-1"></v-divider>
                    <div style="text-transform:uppercase;font-weight:bold;">{{r.prices.length}} prices </div>
                    <div>
                      <v-autocomplete
                        :items="r.prices"
                        label="Prices"
                        height="20px"
                        hide-details
                        item-text="name"
                        return-object
                        v-model="selectedPrice[r.id]"
                      ></v-autocomplete>
                    </div>
                  </div>
                </v-card-title>
              </v-flex>
              <v-flex xs5>
                <div class="text-xs-center py-1">
                  <v-chip small>
                    <v-icon left v-if="r.active" color="success" size="15">check_circle</v-icon>
                    <v-icon left v-else color="error" size="15">cancel</v-icon>
                    <span v-if="r.active" style="text-transform:uppercase;font-weight:bold;"> active </span>
                    <span v-else style="text-transform:uppercase;font-weight:bold;"> not active </span>
                  </v-chip>
                </div>
                <div class="text-xs-center py-1">
                  <v-chip small :color="`${r.web ? 'success' : 'error'}`" dark>
                    <v-icon left v-if="r.web" color="white" size="15">check_circle</v-icon>
                    <v-icon left v-else color="white" size="15">cancel</v-icon>
                    <span v-if="r.web" class="white--text" style="text-transform:uppercase;font-weight:bold;"> web </span>
                    <span v-else class="white--text" style="text-transform:uppercase;font-weight:bold;"> not on web </span>
                  </v-chip>
                </div>
                <v-tooltip top>
                  <template slot="activator">
                    <v-img
                      on="on"
                      v-if="r.image && r.image.url"
                      class="elevation-2 my-2"
                      :src="r.image.url"
                      height="125px"
                    ></v-img>
                  </template>
                  <img v-if="r.image && r.image.url" :src="r.image.url" style="max-width:250px;">
                </v-tooltip>
                <div v-if="selectedPrice[r.id]" style="font-size:11px;">
                  <div style="text-transform:uppercase;font-weight:bold;">price details</div>
                  <div>{{ selectedPrice[r.id].name }}</div>
                  <div>{{ selectedPrice[r.id].value }}</div>
                  <div>{{ selectedPrice[r.id].country.name }}</div>
                  <div>{{ selectedPrice[r.id].from }}</div>
                  <div>{{ selectedPrice[r.id].to }}</div>
                </div>
              </v-flex>
            </v-layout>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small flat color="primary" :loading="loading" @click="edit(r)">edit</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { format, render, cancel, register } from 'timeago.js';
export default {
  props:['resourceSettings', 'resource' , 'resourceKeys', 'loading'],
  data(){
    return {
      menu:{},
      selectedPrice:{},
    }
  },
  methods:{
    
    addToShortlist(id) {
      this.$emit('addToShortlist', id, this.selectedShortList)
      this.selectedShortList = null
    },
    edit(r) {
      this.$emit('editResource', r)
    },
    getFormat(d){
      return format(d)
    },
    clipboardSuccessHandler ({ value, event }){
      this.$emit('copyS', { value, event })
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('copyF', { value, event })
    },
    openURL(url){
      window.open(url, '_blank').blur();
      window.focus()
    }
  },
  computed:{
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },

  }
}
</script>

<style>
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
</style>